import * as Sentry from '@sentry/react'
import { BrowserTracing } from '@sentry/react'

const attachmentUrlFromDsn = (dsn, eventId) => {
  const { host, path, projectId, port, protocol, user } = dsn
  return `${protocol}://${host}${port !== '' ? `:${port}` : ''}${
    path !== '' ? `/${path}` : ''
  }/api/${projectId}/events/${eventId}/attachments/?sentry_key=${user}&sentry_version=7&sentry_client=custom-javascript`
}

const isLocal = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'

export const initSentry = () => {
  const infra = process.env.REACT_APP_INFRA || 'dev'
  let environment = 'development'
  if (infra === 'uat') {
    environment = 'staging'
  } else if (infra === 'prod') {
    environment = 'production'
  }

  if (!isLocal) {
    Sentry.init({
      dsn: 'https://ac8ae5607cc5bd7b328d089fcd652fd0@o4510895913631744.ingest.de.sentry.io/4511054196047952',
      integrations: [new BrowserTracing()],

      enableAutoSessionTracking: true,
      environment,

      // Sessions close after app is 10 seconds in the background.
      sessionTrackingIntervalMillis: 10000,
      // Set tracesSampleRate to 1.0 to capture 100%
      // of transactions for performance monitoring.
      // We recommend adjusting this value in production
      tracesSampleRate: 1.0,
    })
    Sentry.setTag('plateforme', 'backoffice')
    Sentry.setTag('environment', environment)
  }
}

export const captureMessageWithAttachment = (data, error) => {
  if (!isLocal) {
    try {
      Sentry.withScope((scope) => {
        scope.setTransactionName(`front - ${data.request}`)
        const msgId = Sentry.captureMessage(`[GraphQL error]: ${error?.message}`)
        const client = Sentry.getClient()
        const endpoint = attachmentUrlFromDsn(client.getDsn(), msgId)
        const formData = new FormData()
        formData.append(
          'my-attachment',
          // eslint-disable-next-line no-undef
          new Blob(
            [
              JSON.stringify({
                ...data,
                message: error?.message,
                url: window.location.href,
                accessToken: localStorage.getItem('access_token'),
                refreshToken: localStorage.getItem('refresh_token'),
              }),
            ],
            {
              type: 'application/json',
            }
          ),
          'logs.json'
        )
        fetch(endpoint, {
          method: 'POST',
          body: formData,
        }).catch((ex) => {
          // we have to catch this otherwise it throws an infinite loop in Sentry
          console.error(ex)
        })
      })
    } catch (ex) {
      console.error(ex)
    }
  }
}
